var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({
    staticClass: "side-item",
    attrs: {
      "flat": "",
      "outlined": ""
    },
    on: {
      "click": _vm.activate
    }
  }, 'v-card', {
    color: _vm.color
  }, false), [_c('v-card-title', {
    staticClass: "side-item__title"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.content ? [_c('v-spacer'), _c('v-badge', _vm._b({
    staticClass: "side-item__badge",
    attrs: {
      "inline": "",
      "light": "",
      "color": "grey lighten-5"
    }
  }, 'v-badge', {
    content: _vm.content
  }, false))] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }